<template>
  <div>
    <input
      id="fileInputLic"
      type="file"
      ref="fileInputLic"
      style="display: none"
      v-on:change="doUploadLic()"
    />
    <b-form-row>
      <b-col md="6" lg="6" class="mb-2">
        <b-button variant="success" size="sm" @click="showAnexosLic()">
          <i class="fas fa-sync"></i> Atualizar Lista
        </b-button>
      </b-col>
      <b-col md="6" lg="6" class="text-right mb-2">
        <b-button variant="success" size="sm" @click="newAnexoLic()">
          <i class="fa fa-plus"></i> Adicionar
        </b-button>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="12">
        <b-table
          id="tblAnexosLic"
          hover
          bordered
          resposive
          small
          striped
          head-variant="dark"
          primary-key="arquivo_id"
          selectable
          select-mode="single"
          selected-variant="primary"
          show-empty
          tbody-class="font08"
          thead-class="font08"
          empty-text="Sem dados para exibir"
          :items="anexos"
          :fields="campos"
        >
          <template v-slot:cell(actions)="data">
            <b-button
              size="sm"
              title="Alterar"
              variant="success"
              @click="
                doDownloadArquivoLic(data.item.arquivo_id, data.item.nome_arquivo)
              "
            >
              <i class="fas fa-download"></i>
            </b-button>
            <b-button
              size="sm"
              title="Excluir"
              variant="danger"
              @click="doDeleteAnexoLic(data.item.arquivo_id)"
            >
              <i class="fas fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, showError, formatDate } from "@/global";

export default {
  name: "AnexosLicitacao",
  data: function () {
    return {
      anexos: [],
      campos: [
        { key: "nome_arquivo", label: "Arquivo" },
        {
          key: "usuario_id",
          label: "Usuário Upload",
          sortable: true,
          class: "w200-field",
        },
        {
          key: "dt_upload",
          label: "Data Upload",
          sortable: true,
          class: "w140-field",
          formatter: function (val) {
            return formatDate(val, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY HH:mm");
          },
        },
        {
          key: "actions",
          label: "Ações",
          sortable: false,
          class: "w100-field",
        },
      ],
    };
  },
  props: {
    wbs: { type: Object, required: true },
    acao: { type: String, required: true },
  },
  methods: {
    showAnexosLic() {
      let _param = {
        programa_id: this.wbs.programa_id,
        wbs_id: this.wbs.wbs_id,
        tipo: 5
      };
      axios
        .post(`${baseApiUrl}/bid/programawbs/arquivos`, _param)
        .then((resp) => {
          this.anexos = resp.data;
        });
    },
    newAnexoLic() {
      document.getElementById("fileInputLic").click();
    },
    doUploadLic() {
      let formData = new FormData();
      formData.append("file", this.$refs.fileInputLic.files[0]);
      formData.append("tipo", "5");
      axios
        .post(
          `${baseApiUrl}/bid/programawbs/${this.wbs.programa_id}/arquivo/${this.wbs.wbs_id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then(() => {
          this.showAnexosLic();
        })
        .catch((ex) => {
          showError(ex);
          console.log("FAILURE!!", ex);
        });
    },
    doDeleteAnexoLic(arquivoid) {
      axios
        .delete(
          `${baseApiUrl}/bid/programawbs/arquivos/${arquivoid}`
        )
        .then(() => {
          this.showAnexosLic();
        });
    },
    doDownloadArquivoLic(arquivoid, nome_arquivo) {
      axios({
        url: `${baseApiUrl}/bid/programawbs/arquivos/${arquivoid}`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(response.data);
        var fileLink = document.createElement("a");
        fileLink.setAttribute("id", "tempDownloadLinkFile");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", nome_arquivo);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.parentNode.removeChild(fileLink);
      });
    },
  },
  watch: {
    wbs: {
      immediate: true,
      handler() {
        this.showAnexosLic();
      },
    },
  },
};
</script>

<style>
</style>